<div class="flex flex-col  w-full gap-3">
  @for (item of config(); track item.slug) {
    <div class="flex flex-col overflow-hidden transition-all duration-300 rounded-lg bg-neutral">

      <!-- Header -->
      <div (click)="togglePanel(item.slug)" class="w-full cursor-pointer p-3">
        <div class="flex items-center justify-between w-full">
          <span class="cd-text-b2">{{ item.label }}</span>
          <img [style.transform]="isOpen(item.slug) ? 'rotate(90deg)' : 'rotate(0)'"
               alt="Complaints"
               class="filter-neutral-600 h-4 transition-transform duration-200"
               src="/assets/icons/feather/chevron-right.svg">
        </div>
      </div>

      <!-- Content -->
      <div [style.grid-template-rows]="isOpen(item.slug) ? '1fr' : '0fr'"
           class="grid transition-[grid-template-rows] duration-300 ease-in-out">

        <div class="overflow-hidden">
          <div class="pt-0 px-4 pb-4 flex flex-col min-h-0">
            @if (item.template) {
              <ng-container [ngTemplateOutletContext]="{ $implicit: item.slug || '' }"
                            [ngTemplateOutlet]="item.template"/>
            } @else {
              <h2>{{ item.label }}</h2>
            }
          </div>
        </div>

      </div>

    </div>
  }
</div>
